import React, { useEffect, useContext, useState, useReducer } from "react";
import { makeStyles, Grid, Typography, Collapse, RootRef, useMediaQuery, useTheme, IconButton } from "@material-ui/core";
import SortIcon from "@material-ui/icons/Sort";
import { useLocation, useHistory } from "react-router-dom";
import randomMC from "random-material-color";
import { AuthContext } from "../context";
import { TextField, ProductCard, LabCard, Paper, Loader, PopUp, Button, PaperOptions, Popover } from "../components";
import { SearchIcon, GridIcon, RecordIcon } from "../icons";
import { doctorServices, labServices } from "../services";
import { modals } from "../constants";
import { useScroll, useResize, usePopover } from "../hooks";

export default function RequestScreen(props) {
  //const { state } = useContext(AuthContext);
  const [viewList, setViewList] = useState(true);
  const matchesDesktop = useMediaQuery(useTheme().breakpoints.up("md"));
  const matches = useMediaQuery("(min-width:320px) and (max-height:668px)");
  const [buttonActive, setButtonActive] = useState(0);
  const { paperGrow, domRef, onScroll } = useScroll(100);
  const [imageLoaded, setImageLoaded] = useState(false);
  const { collapseH } = useResize(imageLoaded);
  const classes = useStyles({ buttonActive, matches, viewList, collapseH, paperGrow, ...props })();
  const [query, setQuery] = useState("");
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const [modalImage, setModalImage] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalError, setModalError] = useState(false);
  const [forLab, setForLab] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [labs, setLabs] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [changeSize, setChangeSize] = useState(false);
  const { id, open, anchorEl, setAnchorEl } = usePopover();

  const [products, dispatch] = useReducer((myArray, { type, value }) => {
    switch (type) {
      case "add":
        return [...myArray, value];
      case "push":
        return [value, ...myArray];
      case "remove":
        return myArray.filter((_, index) => index !== value);
      case "updateIsSelect":
        return myArray.map((element, index) => {
          if (element._id === value) {
            return {
              ...element,
              isSelect: !element.isSelect,
            };
          }
          return { ...element };
        });
      case "orderBy":
        return myArray.sort(function (a, b) {
          if (a[value].toLowerCase() > b[value].toLowerCase()) {
            return 1;
          }
          if (a[value].toLowerCase() < b[value].toLowerCase()) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });

      default:
        return myArray;
    }
  }, []);

  useEffect(() => {
    async function init() {
      try {
        setLoading(true);
        // const {
        //   response: { products: doctorKit },
        // } = await doctorServices.getDoctorKit({ token: authState.token, _id: authState.user.doctor._id });

        const { status, response } = await labServices.getAllProducts({ token: authState.token, doctorId: authState.user.doctor._id });
        // response.products = response.products.filter(({ _id }) => !doctorKit.map(({ _id }) => _id).includes(_id));
        //console.log("response", response)
        setLoading(false);
        if (status === 200) {
          const orderArray = response.products.sort(function (a, b) {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });
          orderArray.forEach((element, index) => {
            dispatch({
              type: location.state && location.state.productToRequest._id === element._id ? "push" : "add",
              value: {
                ...element,
                isSelect: location.state && location.state.productToRequest._id === element._id ? true : false,
                quantityToAssign: 1,
                index,
              },
            });
          });
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log("Error", e);
      }
      setIsLoaded(true);
    }
    init();
  }, [authState, location, signOut]);

  const updateIsSelect = async (index) => {
    dispatch({ type: "updateIsSelect", value: index });
  };

  const onClickButton = async (button, showLabs) => {
    setButtonActive(button);
    if (showLabs !== forLab) {
      try {
        setLoading(true);
        const { status, response } = await labServices.getLabs({ token: authState.token, doctorId: authState.user.doctor._id });
        setLoading(false);
        if (status === 200) {
          //  console.log("responseLabs", response)
          setLabs(
            response.laboratories.map((lab) => {
              return { ...lab, color: randomMC.getColor({ shades: ["100", "200"] }) };
            })
          );
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log("Error", e);
      }
    }
    setForLab(showLabs);
  };

  const onSubmit = async () => {
    try {
      const productsSelect = products
        .filter((product) => product.isSelect)
        .map((element) => {
          return { _id: element._id };
        });
      setLoading(true);
      const { status, response } = await labServices.addOrder({ products: productsSelect, token: authState.user.token, doctorId: authState.user.doctor._id });
      setLoading(false);
      if (status === 201) {
        setModalName(modals[2]);
        setModal(!modal);
        setModalMessage("Orden creada éxitosamente");
      } else if (status === 200) {
        if (response.error) {
          if (response.error.code === 1015) {
            setModalMessage("Este producto ya tiene una solicitud pendiente de aprobación por parte del laboratorio fabricante");
          }
          setModalError(true);
          setModalName(modals[2]);
          setModal(!modal);
        }
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log("Error", e);
    }
  };

  const filterList = (value) => {
    if (value === "") {
      setFilter(false);
    }
    setQuery(value);
    setFilteredProducts(
      products.filter(
        (element, index) =>
          element.name.toLowerCase().includes(value.toLowerCase()) ||
          element.molecule.toLowerCase().includes(value.toLowerCase()) ||
          element.laboratory.name.toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilter(true);
  };

  const orderList = async (index) => {
    setAnchorEl(null);
    setLoading(true);
    await dispatch({ type: "orderBy", value: index === 0 ? "name" : "molecule" });
    setLoading(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container>
      <PopUp
        modalName={modalName}
        open={modal}
        hideErrorWord
        setModal={() => setModal(!modal)}
        modalImage={modalImage}
        modalError={modalError}
        message={modalMessage}
        modalSubMessage={"Por favor debe estar atento de la confirmación de su pedido."}
      />
      {loading && <Loader loading={true} />}
      <Grid className={classes.container} container>
        <Collapse in={!matchesDesktop ? !paperGrow : true} id={"collapseId"} timeout={250} style={{ width: "100%" }}>
          <Grid className={classes.containerImage} container justify="flex-start">
            <Grid item md={3} xs={6}>
              <img src="../../assets/solicitar-muestras.svg" alt="" onLoad={() => setImageLoaded(true)} />
            </Grid>
            <Grid item xs={6} container alignItems="center" style={{ height: "100%" }}>
              {/* <Typography style={{ fontSize: "1rem" }} align="center" component={"span"} variant={"h2"}>
                ¿Qué estás buscando?
              </Typography> */}
            </Grid>
            <Grid item md={9} className={classes.desktopOptions} container alignItems="flex-start">
              <Grid item md={12}>
                <Typography component="h1" variant="h1">
                  Solicitar Muestras a Laboratorios
                </Typography>
              </Grid>
              <Grid item md={8}>
                <TextField
                  type={"text"}
                  name={"query"}
                  value={query}
                  placeholder={"Solicita muestras al fabricante "}
                  fontWeight="bold"
                  style={{ justifyContent: "flex-end" }}
                  showIcon
                  iconComponent={() => <SearchIcon onClick={() => { }} />}
                  onClickIcon={() => { }}
                  onChange={(e) => filterList(e.target.value)}
                />
              </Grid>
              <Grid item md={4} container justify="space-between" alignItems="center">
                <Grid container justify="flex-end">
                  <IconButton disabled={buttonActive ? true : false} aria-describedby={id} onClick={handleClick} style={{ width: 45, height: 45 }}>
                    {" "}
                    <SortIcon style={{ color: buttonActive ? "#CCCCCC" : "#2196C0" }} />{" "}
                  </IconButton>
                  <IconButton onClick={() => setViewList(true)} style={{ backgroundColor: viewList ? "#2196C0" : "unset", width: 45, height: 45 }}>
                    {" "}
                    <RecordIcon color={viewList ? "white" : "#2196C0"} />{" "}
                  </IconButton>
                  <IconButton onClick={() => setViewList(false)} style={{ backgroundColor: viewList ? "unset" : "#2196C0", width: 45, height: 45 }}>
                    {" "}
                    <GridIcon color={viewList ? "#2196C0" : "white"} />{" "}
                  </IconButton>
                </Grid>
              </Grid>
              <Grid item md={12} container justify="space-between">
                <Grid item md={6} className={classes.buttonGroup} container spacing={2} style={{ margin: 0, width: "100%" }}>
                  <Grid item md={6}>
                    <Button onClick={() => onClickButton(0, false)}>PRODUCTOS</Button>
                  </Grid>
                  <Grid item md={6}>
                    <Button onClick={() => onClickButton(1, true)}>LABORATORIOS</Button>
                  </Grid>
                </Grid>
                {products.some((element) => element.isSelect) && (
                  <Grid item md={5} container>
                    <Button onClick={onSubmit}>SOLICITAR MUESTRAS</Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
        <Paper className={classes.paperClass}>
          <PaperOptions
            title={"Muestras"}
            query={query}
            changeSize={changeSize}
            setChangeSize={(value) => setChangeSize(value)}
            viewList={viewList}
            setViewList={(value) => setViewList(value)}
            filterList={(e) => filterList(e)}
            buttons
            buttonActive={buttonActive}
            textButtonL={"PRODUCTOS"}
            textButtonR={"LABORATORIOS"}
            onClickButton={(value1, value2) => onClickButton(value1, value2)}
            orderList={(index) => orderList(index)}
            handleClickPopover={(event) => handleClick(event)}
          />
          <Popover id={id} open={open} anchorEl={anchorEl} handleClose={handleClose} orderList={(index) => orderList(index)} />
          <RootRef rootRef={domRef}>
            <Grid container spacing={2} className={classes.scrollList} onScroll={onScroll}>
              {!products && <></>}
              {forLab &&
                labs.map((lab, index) => (
                  <Grid item sm={viewList ? 12 : 3} xs={viewList ? 12 : 6} key={index} style={{ marginBottom: labs.length - 1 === index ? 50 : 0 }}>
                    <LabCard lab={lab} viewList={viewList} />
                  </Grid>
                ))}
              {!forLab &&
                isLoaded &&
                !filter &&
                products.map((product, index) => (
                  <Grid item sm={viewList ? 12 : 3} xs={viewList ? 12 : 6} key={index} style={{ marginBottom: products.length - 1 === index ? 50 : 0 }}>
                    <ProductCard
                      viewList={viewList}
                      product={product}
                      productsList={products}
                      hideQuantity
                      onClickLab={() => {
                        history.push({ pathname: "/lab-support", state: { _id: product.laboratory._id } });
                      }}
                      lab
                      labName={product.laboratory.owner.name.toUpperCase()}
                      isSelect={product.isSelect}
                      req
                      onClickSelect={() => updateIsSelect(product._id)}
                      onClickRequest={() => {
                        setModal(!modal);
                        setModalName(modals[3]);
                        setModalImage(product.product[0].logo);
                      }}
                    />
                  </Grid>
                ))}
              {filter &&
                filteredProducts.map((product, index) => (
                  <Grid item sm={viewList ? 12 : 3} xs={viewList ? 12 : 6} key={index} style={{ marginBottom: products.length - 1 === index ? 50 : 0 }}>
                    {
                      <ProductCard
                        viewList={viewList}
                        product={product}
                        productsList={products}
                        hideQuantity
                        onClickLab={() => {
                          setModalName(modals[5]);
                          setModal(!modal);
                          console.log({ product });
                        }}
                        lab
                        isSelect={product.isSelect}
                        req
                        onClickSelect={() => updateIsSelect(product._id)}
                        onClickRequest={() => {
                          setModal(!modal);
                          setModalName(modals[3]);
                          setModalImage(product.product[0].logo);
                        }}
                      />
                    }
                  </Grid>
                ))}
            </Grid>
          </RootRef>
        </Paper>
      </Grid>
      {!matchesDesktop && products.some((element) => element.isSelect) && (
        <Grid container className={classes.containerBtn}>
          <Button onClick={onSubmit} fullWidth className={classes.btn}>
            SOLICITAR MUESTRAS
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

const useStyles = ({ buttonActive, matches, viewList, collapseH, paperGrow, ...props }) =>
  makeStyles((theme) => ({
    container: {
      display: "block",
      height: "100%",
      [theme.breakpoints.up("md")]: {
        padding: "50px 50px 0 50px",
      },
    },
    containerBtn: {
      position: "fixed",
      bottom: "calc(90px + env(safe-area-inset-bottom, 0px))",
      padding: "0 12px",
      zIndex: 3,
      "& button": {
        backgroundColor: theme.palette.secondary.main,
        color: "#FFF",
        height: 41,
        borderRadius: 20.5,
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
    },
    buttonGroup: {
      "& div:nth-child(1)": {
        paddingLeft: 0,
        paddingTop: 0,
        "& button": {
          backgroundColor: buttonActive ? "#FFF" : theme.palette.secondary.main,
          color: buttonActive ? theme.palette.secondary.main : "#FFF",
          border: buttonActive ? `1px solid ${theme.palette.secondary.main}` : "unset",
          boxSizing: "border-box",
          "&:hover": {
            backgroundColor: buttonActive ? "#FFF" : theme.palette.secondary.main,
          },
        },
      },
      "& div:nth-child(2)": {
        paddingRight: 0,
        paddingTop: 0,
        "& button": {
          backgroundColor: buttonActive ? theme.palette.secondary.main : "#FFF",
          color: buttonActive ? "#FFF" : theme.palette.secondary.main,
          border: `1px solid ${theme.palette.secondary.main}`,
          boxSizing: "border-box",
          "&:hover": {
            backgroundColor: buttonActive ? theme.palette.secondary.main : "#FFF",
          },
        },
      },
    },
    containerImage: {
      alignItems: "flex-start",
      padding: "5px 25px 9px 45px",
      height: "100%",
      "& div:nth-child(1)": {
        "& img": {
          [theme.breakpoints.up("md")]: {
            width: "100%",
          },
        },
      },
      "& > div:nth-child(2)": {
        [theme.breakpoints.up("md")]: {
          display: "none",
        },
      },
      [theme.breakpoints.up("md")]: {
        alignItems: "center",
        padding: "0 0 0 8px",
      },
    },
    desktopOptions: {
      display: "none",
      padding: "0 0 0 40px",
      height: "100%",
      position: "relative",
      "& > div:nth-child(3)": {
        flexDirection: "row",
        [theme.breakpoints.up("md")]: {
          flexDirection: "column",
        },
      },
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    paperClass: {
      height: paperGrow ? "100%" : "calc(100% - 117px)",
      [theme.breakpoints.up("md")]: {
        height: `calc(100% - ${collapseH}px)`,
      },
    },
    scrollList: {
      height: "calc(100% - 139.66px)",
      [theme.breakpoints.up("md")]: {
        height: "98%",
      },
      [theme.breakpoints.down("sm")]: {
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0, .1)",
        },
      },
      overflowY: "scroll",
      display: viewList ? "block" : "flex",
      paddingTop: 0,
      width: "100%",
      margin: 0,
      "&::-webkit-scrollbar": {
        width: "4px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "10px",
      },
    },
  }));
